import { render, staticRenderFns } from "./BaseSwitch.vue?vue&type=template&id=62248ec4&scoped=true&"
import script from "./BaseSwitch.vue?vue&type=script&lang=ts&"
export * from "./BaseSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSwitch.vue?vue&type=style&index=0&id=62248ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62248ec4",
  null
  
)

export default component.exports